import { useState, useRef, useEffect } from "react";
import { Send, Smile, Phone, Video, Search } from "lucide-react";

// لیست پاسخ‌های از پیش تعریف‌شده با کلمات کلیدی
const predefinedResponses = [
  {
    keywords: ["نام شرکت", "اسم شرکت", "شرکت شما"],
    response:
      "نام شرکت ما عمران است. ما در زمینه خدمات گمرکی و تجاری فعالیت می‌کنیم.",
  },
  {
    keywords: ["خدمات", "چه خدماتی", "سرویس"],
    response:
      "ما خدمات گمرکی، مشاوره تجاری، و مدیریت کوتاژ را ارائه می‌دهیم. برای جزئیات بیشتر، لطفاً سوال دقیق‌تری بپرسید!",
  },
  {
    keywords: ["تماس", "ارتباط", "شماره تماس"],
    response:
      "برای تماس با ما، می‌توانید از شماره 021-12345678 یا ایمیل info@omran.com استفاده کنید.",
  },
  {
    keywords: ["ساعات کاری", "زمان کار"],
    response: "ساعات کاری ما از شنبه تا پنج‌شنبه، 9 صبح تا 5 عصر است.",
  },
  {
    keywords: ["کوتاژ چیست", "کوتاژ یعنی چی"],
    response:
      "کوتاژ شماره‌ای است که برای اظهارنامه‌های گمرکی استفاده می‌شود تا فرآیند ترخیص کالا را شناسایی کند.",
  },
];

const Messages = () => {
  const [messages, setMessages] = useState([
    {
      id: 1,
      from: "support",
      text: "سلام! خوش آمدید. سوال خود را بپرسید تا راهنمایی کنم.",
      time: "الان",
    },
  ]);
  const [newMsg, setNewMsg] = useState("");
  const messagesEndRef = useRef(null);

  // اسکرول خودکار به آخر پیام‌ها
  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  const sendMessage = (text) => {
    if (!text.trim()) return;

    // افزودن پیام کاربر
    const userMsg = { id: Date.now(), from: "user", text, time: "الان" };
    setMessages((prev) => [...prev, userMsg]);
    setNewMsg("");

    // جستجوی پاسخ بر اساس کلمات کلیدی
    const userText = text.toLowerCase();
    const matchedResponse = predefinedResponses.find((item) =>
      item.keywords.some((keyword) => userText.includes(keyword.toLowerCase()))
    );

    // پاسخ پشتیبانی
    setTimeout(() => {
      const supportMsg = {
        id: Date.now() + 1,
        from: "support",
        text: matchedResponse
          ? matchedResponse.response
          : "لطفاً سوال خود را واضح‌تر مطرح کنید یا با پشتیبانی تماس بگیرید.",
        time: "الان",
      };
      setMessages((prev) => [...prev, supportMsg]);
    }, 500);
  };

  return (
    <div
      className="flex flex-col h-[calc(100vh-60px)] bg-gray-100 mt-16"
      dir="rtl"
    >
      {/* Header */}
      <div
        className="
  flex items-center justify-between
  p-4
  bg-white border-b border-gray-200 shadow-lg
  mt-0      
  sm:mt-0   
  md:mt-4
  lg:mt-4  
  xl:mt-4   
"
      >
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-full bg-green-500 flex items-center justify-center text-white font-bold">
            پ
          </div>
          <div className="font-bold text-lg text-gray-900">پشتیبانی آنلاین</div>
        </div>
        <div className="flex gap-4 text-gray-600">
          <Phone className="w-5 h-5 cursor-pointer hover:text-green-500 transition-colors" />
          <Video className="w-5 h-5 cursor-pointer hover:text-green-500 transition-colors" />
          <Search className="w-5 h-5 cursor-pointer hover:text-green-500 transition-colors" />
        </div>
      </div>

      {/* Messages */}
      <div className="flex-1 overflow-y-auto p-4 space-y-3 bg-gray-50">
        {messages.map((msg) => (
          <div
            key={msg.id}
            className={`flex ${
              msg.from === "user" ? "justify-end" : "justify-start"
            } animate-fade-in`}
          >
            <div
              className={`px-4 py-2 rounded-2xl max-w-xs md:max-w-md shadow-md break-words transition-all duration-300 ${
                msg.from === "user"
                  ? "bg-green-500 text-white rounded-br-none"
                  : "bg-white text-gray-900 rounded-bl-none border border-gray-200"
              }`}
            >
              {msg.text}
              <div className="text-xs text-gray-500 mt-1 text-right">
                {msg.time}
              </div>
            </div>
          </div>
        ))}
        <div ref={messagesEndRef} />
      </div>

      {/* Input Box */}
      <div className="flex items-center gap-3 p-4 border-t border-gray-200 bg-white shadow-inner">
        <Smile className="text-gray-500 w-6 h-6 cursor-pointer hover:text-green-500 transition-colors" />
        <input
          type="text"
          className="flex-1 bg-gray-100 rounded-full px-4 py-2.5 outline-none text-right text-base focus:ring-2 focus:ring-green-500 transition-all"
          placeholder="پیام خود را تایپ کنید..."
          value={newMsg}
          onChange={(e) => setNewMsg(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && sendMessage(newMsg)}
        />
        <button
          onClick={() => sendMessage(newMsg)}
          className="bg-green-500 text-white p-2.5 rounded-full hover:bg-green-600 active:bg-green-700 transition-all"
        >
          <Send className="w-5 h-5" />
        </button>
      </div>
    </div>
  );
};

export default Messages;
